import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";
import QRCode from "qrcode.react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { API_GET_LAUNDRYBOX } from "api/laundrybox-management";
import LaundryBoxOrderTable from "components/Tables/Orders/LaundryBoxOrderTable";
import { API_ASSIGN_ORDER_TO_DRIVER } from "api/laundry-management";
import DriverMap from "components/Map/DriverMap";
import { Slider, Table, Button, Modal, Col, Row } from "antd";
import { API_NEARBY_DRIVER } from "api/order-management";
import userplace from "../../../../assets/img/orders/orderDetail/userplace.png";
import mapIcon from "../../../../assets/img/orders/orderDetail/map.png";
import { toast } from "react-toastify";
import { API_NEARBY_DRIVER_LAUNDRY_BOX } from "api/laundrybox-management";

const ViewLaundryBox = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [isModalVisibleDriver, setIsModalVisibleDriver] = useState(false);
  const [drivers, setDrivers] = useState();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [radius, setRadius] = useState(1000); // Default radius value in meters
  const [selectedDriverEmail, setSelectedDriverEmail] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  console.log(id,'iamlaundryboxid')

  // const data = location.state && location.state.data;
  const [qrCode, setQrCode] = useState("");
  const handleDriverSelect = (email) => {
    setSelectedDriverEmail(email);
  };

  const qrCodeRef = useRef(null);

  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  const fetchDataOrder = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_LAUNDRYBOX(id);
      console.log("provider", newData);
      setData(newData?.laundry_box);
      // setStatus(newData?.order?.order_status);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  const fetchDataDrivers = async () => {
    try {
      // setLoading(true);
      const payload = {
        laundry_box_id: id,
        search_radius: radius,
      };
      // const newData = await API_LIST_LAUNDRY_MEN(params);
      const newData = await API_NEARBY_DRIVER_LAUNDRY_BOX(payload);
      console.log("provider", newData);
      setDrivers(newData?.laundry_men);
      // setLoading(false);
      setPagination({ ...pagination, total: newData.totalLaundryMen }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const handleAssignDriver = async (driver) => {
    // Handle driver assignment logic here
    console.log("Assigned driver:", driver);

    try {
      const payload = {
        laundry_man_id: driver?._id,
        laundry_box_id: id,
      };

      const response = await API_ASSIGN_ORDER_TO_DRIVER(payload);
      console.log("response", response);
      if (response) {
        setIsModalVisibleDriver(false);

        toast.success(response?.message);
      }
      fetchDataOrder(); // Refresh data after assigning order
    } catch (error) {
      console.error("Error assigning order to driver:", error);
      // message.error("Failed to assign order to driver");
    }
  };
  console.log("data lau", data);
  const columns = [{ title: "Name", dataIndex: "first_name", key: "first_name" },{ title: "Email", dataIndex: "email", key: "email" },{ title: "Contact", dataIndex: "phone_no", key: "phone_no" },{
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleAssignDriver(record)}>
          Assign
        </Button>
      ),
    },
  ];

  const driversNew = drivers?.map((driver) => ({
    profile: driver?.profile_image[0]?.file_url
      ? CONSTANTS?.IMG_DIRECTORY + driver?.profile_image[0]?.file_url
      : userplace,
    name: `${driver?.first_name} ${driver?.last_name}`,
    email: driver?.email,
    contact: driver?.phone_no,
    latitude: driver?.geo?.coordinates[0],
    longitude: driver?.geo?.coordinates[1],
  }));
  useEffect(() => {
    fetchDataOrder();
    fetchDataDrivers();
  }, [id]);
  useEffect(() => {
    if (id) {
      setQrCode(id);
    }
  }, [id]);

  const rowClassName = (record) => {
    return record.email == selectedDriverEmail ? "selected-rows-driver" : "";
  };
  const rowStyles = (record) => {
    return record.email === selectedDriverEmail
      ? { backgroundColor: "blue !important", color: "white" }
      : {};
  };
  // const downloadQRCode = () => {
  //   if (!qrCodeRef.current) return;

  //   const canvas = document.createElement("canvas");
  //   const context = canvas.getContext("2d");
  //   const qrCodeCanvas = qrCodeRef.current.querySelector("canvas");

  //   const qrCodeImage = new Image();
  //   qrCodeImage.src = qrCodeCanvas.toDataURL("image/png");

  //   qrCodeImage.onload = () => {
  //     canvas.width = qrCodeCanvas.width;
  //     canvas.height = qrCodeCanvas.height;

  //     const centerX = (canvas.width - qrCodeImage.width) / 2;
  //     const centerY = (canvas.height - qrCodeImage.height) / 2;

  //     context.drawImage(qrCodeImage, centerX, centerY);

  //     const pdf = new jsPDF();
  //     pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0);
  //     pdf.save("QRCode.pdf");
  //   };
  // };
  const downloadQRCode = () => {
    if (!qrCodeRef.current) return;

    const qrCodeCanvas = qrCodeRef.current.querySelector("canvas");
    if (!qrCodeCanvas) return;
    html2canvas(qrCodeCanvas)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save("QRCode.pdf");
      })
      .catch((error) => {
        console.error("Error generating QR code image:", error);
      });

    console.log("QR Code Canvas:", qrCodeCanvas);
  };

  // const downloadQRCode = () => {
  //   if (!qrCodeRef.current) return;

  //   const canvas = qrCodeRef.current.querySelector("canvas");

  //   const qrCodeImage = new Image();
  //   qrCodeImage.src = canvas.toDataURL("image/png");

  //   qrCodeImage.onload = () => {
  //     const pdf = new jsPDF();
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     // Get the dimensions of the QR code image
  //     const qrWidth = qrCodeImage.width;
  //     const qrHeight = qrCodeImage.height;

  //     // Calculate the center position
  //     const x = (pageWidth - qrWidth) / 2;
  //     const y = (pageHeight - qrHeight) / 2;

  //     // Add the QR code image to the PDF
  //     pdf.addImage(qrCodeImage.src, "PNG", x, y, qrWidth, qrHeight);
  //     pdf.save("QRCode.pdf");
  //   };
  // }

  return (
    <>
      <div className="flex gap-8">
        <div style={styles.container} className="min-h-[37rem]">
          <table style={styles.table}>
            <tbody>
              {/* <div className="flex justify-between">
                <div className="flex w-[5rem] cursor-pointer items-center gap-2"
                  onClick={() => {navigate(-1)}}><MdOutlineArrowBack className="cursor-pointer" style={{ fontSize: "17px" }}/><p>Back</p></div>
                <Button
                  className="btn-gradient  ml-2 flex w-36 items-center justify-center p-4 text-[white]"
                  icon={<img src={mapIcon} style={{ height: "1rem", width: "1rem" }} alt = ''/>}
                  onClick={() => setIsModalVisibleDriver(true)}
                >
                  Assign Driver
                </Button>
              </div> */}

              <p className="mb-4 text-center text-[20px] ">
                {t("View Laundry Box")}
              </p>
              <hr className="mb-4" />

              {/* Store Owner Information */}
              <div className="mb-3 flex justify-around">
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Name")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] ">
                    {data?.name}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Description")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] ">
                    {data?.description}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Maximum Item Capacity")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] ">
                    {data?.max_item_capacity}
                  </td>
                </tr>
              </div>

              <div className="mb-3 flex justify-around">
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Location")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] ">
                    {data?.location_details?.address}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {/* {t("Description	")} */}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                    {/* {data?.store_owner_info?.[0]?.email} */}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {/* {t("Maximum Item Capacity	")} */}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                    {/* {data?.store_owner_info?.[0]?.phone_no} */}
                  </td>
                </tr>
              </div>
              <div
                className="mb-4 flex justify-center text-center"
                ref={qrCodeRef}
              >
                <img src={data?.qr_code} />
                {/* {qrCode && <QRCode value={qrCode} />} */}
              </div>
              <div className="text-center">
                {/* <button
                className="rounded bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700"
                onClick={downloadQRCode}
              >
                Download QR Code
              </button> */}
                <a
                  href={data?.qr_code}
                  download="QR code.png"
                  className="rounded bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700"
                >
                  {/* <img src={data?.qr_code} /> */}
                  {t("Download")}
                </a>
              </div>
            </tbody>
          </table>
        </div>
      </div>
      <LaundryBoxOrderTable id = {id} />
      <Modal
        title="Select Driver"
        className="order-driver-modal driver-mod"
        visible={isModalVisibleDriver}
        onCancel={() => setIsModalVisibleDriver(false)}
        footer={null}
        centered
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Table
              columns={columns}
              dataSource={drivers}
              rowKey="email"
              style={{ width: "100%" }}
              rowClassName={rowClassName}
              rowStyle={rowStyles}

              // pagination={{ pageSize: 5 }}
            />
          </Col>
          <Col span={12}>
            <div style={{ height: "400px" }}>
              {" "}
              {/* Ensure the container has a defined height */}
              <DriverMap
                drivers={driversNew}
                onDriverSelect={handleDriverSelect}
                radius={radius}
                orderData={data}
              />
            </div>
            <Slider
              min={500}
              max={5000}
              step={100}
              value={radius}
              onChange={(value) => setRadius(value)}
              // tooltipVisible
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};
// style={{ background: "#e5e2e2" }}

const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};
export default ViewLaundryBox;
